import s from "./_coreJsData.js";
var a = s, e = function() {
  var r = /[^.]+$/.exec(a && a.keys && a.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function t(r) {
  return !!e && e in r;
}
var c = t;
export {
  c as default
};
//# sourceMappingURL=_isMasked.js.map
